document.addEventListener('DOMContentLoaded', function() {
   
    // Slider logic variables
    let target = 0;
    let current = 0;
    let ease = 0.075;
    let currentPart = 1;
    let previousPart = null;

    const slider = document.querySelector('.slider');
    const sliderWrapper = document.querySelector('.slider-wrapper');
    const projectData = JSON.parse(sliderWrapper.getAttribute('data-projects'));
    const postCount = projectData.length;
    const activeSlide = document.querySelector('.active-slide');
    const markerWrapper = document.querySelector('.marker-wrapper');

    let maxScroll = sliderWrapper.offsetWidth - window.innerWidth;
    const postWidth = sliderWrapper.offsetWidth / postCount;
    maxScroll = postWidth * postCount - window.innerWidth;

    function lerp(start, end, factor) {
        return start + (end - start) * factor;
    }


function updateActiveSliderNumber(markerMove, markerMaxMove) {
    const partWidth = markerMaxMove / postCount;
    const num = window.innerWidth <= 670 ? 75 : 150;
    let newPart = Math.round((markerMove - num) / partWidth) + 1;
    newPart = Math.max(1, newPart);
    newPart = Math.min(postCount, newPart);
    activeSlide.textContent = `${newPart}/${postCount}`;

    const projectTitleSlide = document.querySelector('.project-title-slide');
    const projectYearSlide = document.querySelector('.project-year-slide');
    projectTitleSlide.textContent = projectData[newPart - 1].title;
    projectYearSlide.textContent = projectData[newPart - 1].year;

    currentPart = newPart;
}

    function update() {
        current = lerp(current, target, ease);

        gsap.set(".slider-wrapper", {
            x: -current,
        });

        let moveRatio = current / maxScroll;

        let markerMaxMove = window.innerWidth - markerWrapper.offsetWidth - 170;

        let markerMove = 70 + moveRatio * markerMaxMove;

        gsap.set('.marker-wrapper', {
            x: markerMove,
        });

        updateActiveSliderNumber(markerMove, markerMaxMove);

        requestAnimationFrame(update);
    }

    window.addEventListener('resize', function() {
        maxScroll = sliderWrapper.offsetWidth - window.innerWidth;
    });

      const arrowText = document.querySelector('.arrow-container'); 
   

    window.addEventListener('wheel', function(e) {
        target += e.deltaY;
        target = Math.max(0, target);
        target = Math.min(maxScroll, target);

        
    if (!arrowText) return; 
    if (target > 100) { 
        arrowText.style.opacity = 0; 
    } else { 
        arrowText.style.opacity = 1; 
    }
    });

    // Touch event handling for mobile devices
    let touchStartX = 0;
    let touchEndX = 0;
    const touchSensitivity = window.innerWidth <= 768 ? 2 : 0.5;

    sliderWrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        console.log('Touch start:', touchStartX);
        
    });

    sliderWrapper.addEventListener('touchmove', function(e) {
        touchEndX = e.touches[0].clientX;
        let touchDelta = (touchStartX - touchEndX) * touchSensitivity;
        target += touchDelta;
        target = Math.max(0, target);
        target = Math.min(maxScroll, target);
        touchStartX = touchEndX;
        console.log(target)
        // Hide arrow text after 100 pixels of swipe movement on mobile
        if (!arrowText) return;
        if (target > 100) {
            arrowText.style.opacity = 0;
        } else {
            arrowText.style.opacity = 1;
        }
    });


    // Start the update loop
    update();



});